import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ADD_NEW, ROUTE_BRAND, ROUTE_UPDATE_BRAND} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Brand = lazy(() =>
  import('../../../screens/Brand')
    .then(module => ({default: module.Brand})));

const AddNew = lazy(() =>
  import('../../../screens/Brand')
    .then(module => ({default: module.AddNew})));

const UpdateBrand = lazy(() =>
  import('../../../screens/Brand')
    .then(module => ({default: module.EditBrand})));

const BrandNavigation = [
  {
    path: ROUTE_BRAND,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Brand />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_NEW,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddNew />
      </Suspense>
    ),
  },
  {
    path: ROUTE_UPDATE_BRAND,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <UpdateBrand />
      </Suspense>
    ),
  },
];

export default BrandNavigation;
